import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { FormControl, InputLabel, Input, FormHelperText, Alert, Select, Skeleton} from "@mui/material"
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Typography } from '@mui/material';
import { printVariable } from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import useAlert from "@hooks/useAlert"
import MenuItem from '@mui/material/MenuItem';
import {download} from "@util/helper"
const defSmst = {id:-1, year:'', gisu: ''}
const ManagerRegiPartDownload = React.forwardRef((props, ref) =>  {
  const {callback, smstPhase} = props

  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const [file, set_file] = React.useState(null)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {alert, renderAlert} = useAlert()
  const [smst, set_smst] = useState(defSmst)
  const [smstList, set_smstList] = useState([])
  const [open, set_open] = React.useState(false)
  const updateRef = React.useRef(false)

  const onChangeSmstId = (e) => {
    const smst = smstList.find(r => r.id === e.target.value)
    if(smst) {
      set_smst(smst)
    }
  }

  const onChangeFile = (e) => {
    const file = e.target.files[0]
    set_file(file)
  }
  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {

      if(callback && updateRef.current) {
        callback()
      }
      set_smst(defSmst)
      set_file(null)
      set_open(false)
    }
  }

  const handleOpen = () => {
    set_open(true)
  }

  React.useImperativeHandle(ref, () =>({
    open: () => {
      handleOpen()
    },
    close: () => {
      handleClose()
    }
  }))

	const fetchSmst = async () => {
		const url = `/smst/standby/lecture/${schola.id}`
    openIndicator()
		const resp = await WebService.get(url, {})
    closeIndicator()
		if (resp.repCode !== "ack") {
			// openSnackbar(resp.repMessage);
			alert(resp.repMessage)
			return
		}
		const repMessage = JSON.parse(resp.repMessage)
		const smst = JSON.parse(repMessage.smst)
		return smst
	}

  const fetchSmstList = async() => {
		const url = `/smst/last/5/${schola.id}`
    openIndicator()
		const resp = await WebService.get(url, {})
    closeIndicator()
		if (resp.repCode !== "ack") {
			alert(resp.repMessage)
			return
		}

		const repMessage = JSON.parse(resp.repMessage)
		const smstList = JSON.parse(repMessage.records)
    return smstList.filter(r => Math.floor(+r.phase) === +smstPhase)
		// return smstList.filter(r => r.phase != 2)
  }

  const handleDownload= async() => {
    if(!smst.id) {
      alert('년도/기수를 선택해 주세요.')
      return
    }

    const url = `/regi/download/${schola.id}/${smst.id}`
    await download(url)
    handleClose()
    
  }

  const onLoad = async() => {
    if(open) {
      const smstList = await fetchSmstList()
      if(smstList) {
        set_smstList(smstList)
        if(smstList.length == 1) {
          set_smst(smstList[0])
        }
      }
    }
  }

  React.useEffect(() => {
    if(open) {
      onLoad()
    }
  },[open])

  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {schola.name} 
          </Typography>
          <Typography variant='body' align='center'>수강(신청) 명단 다운로드</Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
              <FormControl fullWidth sx={{mt:2, mb:2}}>
                  <InputLabel id='gisu' size='small'>
                    년도/기수
                  </InputLabel>
                      <Select
                        labelId='gisu'
                        required
                        label='년도/기수'
                        name={"smstId"}
                        value={smst?.id}
                        size='small'
                        onChange={async (e) => {
                          onChangeSmstId(e)
                        }}>
                        {smstList.map((s, index) => {
                          return (
                            <MenuItem key={index} value={s.id}>
                              {s.year}/{s.gisu}
                            </MenuItem>
                          )
                        })}
                      </Select>
                </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>취소</Button>
          <Button onClick={handleDownload} variant='contained' disabled={ smst.id == -1}>다운로드</Button>
        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
		
	)
})

export default ManagerRegiPartDownload
